import type { ReactNode } from 'react';

import { cx } from '../../lib/cx';
import { Icon, type IconName } from '../Icon';

import styles from './Alert.module.css';

export type AlertTone = 'info' | 'success' | 'danger' | 'warning';

export interface AlertProps {
  tone?: AlertTone;
  title?: ReactNode;
  children?: ReactNode;
  /** Announce to screen readers as soon as it appears. */
  live?: boolean;
  className?: string;
}

const ICONS: Record<AlertTone, IconName> = {
  info: 'focus',
  success: 'check-circle',
  danger: 'blocked',
  warning: 'timer',
};

/** A message about the state of things: what happened, what failed, what to mind. */
export function Alert({ tone = 'info', title, children, live, className }: AlertProps) {
  return (
    <div role={live ? 'status' : undefined} className={cx(styles.alert, styles[tone], className)} data-tone={tone}>
      <Icon name={ICONS[tone]} size={18} className={styles.icon} />
      <div className={styles.text}>
        {title ? <p className={styles.title}>{title}</p> : null}
        {children ? <div className={styles.body}>{children}</div> : null}
      </div>
    </div>
  );
}
